import { Component, OnInit, Input, Output, EventEmitter, Renderer2 } from '@angular/core';
import { CdkDrag, CdkDragEnd, DragRef } from '@angular/cdk/drag-drop';
import { Coordinates } from 'src/app/reports/components/report/models/coordinates.model';
import { ArrayInfo } from 'src/app/reports/models/array-info.model';
import { ReportEntity } from 'src/app/reports/components/report/models/report-entity.model';
import { Configuration } from 'src/app/reports/components/report/models/configuration.model';
import { DropItemService } from './drop-item.service';
import { BaseComponent } from 'src/app/reports/shared/utils/base.component';

@Component({
  selector: 'app-drop-item',
  templateUrl: './drop-item.component.html',
  styleUrls: ['./drop-item.component.scss']
})
export class DropItemComponent extends BaseComponent implements OnInit {

  defaultCoodinates : Coordinates;

  //#region Inputs
  @Input() disabled : boolean = false;

  @Input() entity : ReportEntity;
  @Input() dataSource : Array<any>;
  @Input() cdkDragRef : CdkDrag;
  @Input() scale : number;

  @Input() columnDragulaGroup : string;
  @Input() linkGroupName: string;

  //#endregion

  //#region Outputs

  @Output() onStopMove = new EventEmitter<CdkDragEnd>();
  @Output() onMove = new EventEmitter<ReportEntity>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onMainChanged = new EventEmitter<any>();

  //#endregion

  //#region Properties

  changed : boolean = false;

  dragRef : DragRef<any>;

  //#endregion

  //#region Ctor

  constructor(private render : Renderer2,
    private service : DropItemService) {
    super();
  }

  //#endregion

  //#region Interfaces Implementations

  ngOnInit() {
    this.dragRef = this.cdkDragRef._dragRef;

    this.updateEntityCoordinates();

    this.setListenersDragEvents();

    this.listenUpdateCoordinatesEvent();
  }

  //#endregion

  //#region Click Events
  onDeleteClick(){
    this.onDelete.emit(this.entity);
  }

  onMainClick(){
    this.onMainChanged.emit(this.entity);
  }

  listenUpdateCoordinatesEvent(){
    this.subscription.add(
      this.service.updateCoordinates.subscribe(value =>{
        setTimeout(() => {
          this.adjustCoordinatesOfDropedItens();
        }, 100);
      })
    );
  }

  //#endregion

  //#region Drag Listeners Events

  setListenersDragEvents(){
    this.listenMouseDownDragRefEvent();
    this.listenMovedDragEvent();
    this.listenMoveEndedDragEvent();
  }


  listenMouseDownDragRefEvent() {
    // this method is needed because the CdkDrag libary fire a stopPropagration on mousedown event,
    // this avoid the dragula to detect the event and made the dragging correctly

    let element = this.dragRef.getRootElement();

    this.render.listen(element, 'mousedown', (event) => {
      this.verifyDragMouseEvent(event);
    });

    this.render.listen(element, 'mouseover', (event) => {
      this.verifyDragMouseEvent(event);
    });
  }

  verifyDragMouseEvent(event: any) {
    if (!this.disabled) {
      let dragRef: any = this.dragRef,
        isDisabled = event.target.classList.contains('arrow');

      dragRef.disabled = isDisabled;
      dragRef.data._disabled = isDisabled;
    }
  }

  listenMovedDragEvent(){
    this.subscription.add(
      this.cdkDragRef.moved.subscribe(event => {

        if(this.defaultCoodinates && this.defaultCoodinates != null)
          this.setCoordinates(this.defaultCoodinates);
        else {
          let entity = this.entity,
            config : Configuration ={
              Coordinates: this.getCurrentCoordinates()
            };

          let ref : any = this.dragRef;

          this.setCoordinatesToElement(ref._rootElement, config.Coordinates);

          entity.Configuration = this.convertConfigurationToJsonString(config);
          this.onMove.emit(entity);
        }
      })
    )
  }

  listenMoveEndedDragEvent(){
    this.subscription.add(
      this.cdkDragRef.ended.subscribe(event => {
        this.adjustCoordinatesOfDropedItens();
        this.onStopMove.emit(event);
      })
    )
  }
  //#endregion

  //#region Drop and Coordinates Methods

  updateEntityCoordinates(){
    if(this.entity.Configuration){
      let config : Configuration = this.convertJsonStringToConfiguration(this.entity.Configuration);
      this.setCoordinates(config.Coordinates);
    }
  }

  adjustCoordinatesOfDropedItens(){
    let obj :any = this.dragRef,
        info = this.getArrayInformation();

    let index = (info.index + 1),
        factor = index * (-200),
        addition = index * 70,
        x_limit = factor + 150 + addition,
        y_limit = ( (this.scale <= 1 ? -35 : -10) / Math.pow(this.scale,3) ),
        x = obj._activeTransform.x,
        y = obj._activeTransform.y;


    if( x  <= x_limit) {
      x = x_limit;
      this.changed = true;
    }

    if( y <= y_limit){
      y = y_limit + (10 / Math.pow(this.scale,3));
      this.changed = true;
    }

    let coordinates : Coordinates = {
      x : x,
      y : y
    };

    if(this.changed)
      this.setCoordinatesWithTimer(coordinates);
  }

  setCoordinatesWithTimer(coordinates : Coordinates){
    setTimeout(()=> {
      if(this.changed){
        this.changed = false;
        this.setCoordinates(coordinates);

        setTimeout(() => {
          this.onMove.emit();
        }, 100);

      }
    },300)
  }

  setCoordinates(coordinates: Coordinates) {
    const ref: any = this.dragRef;

    if (coordinates) {
      ref._activeTransform.x = coordinates.x;
      ref._passiveTransform.x = coordinates.x;

      ref._activeTransform.y = coordinates.y;
      ref._passiveTransform.y = coordinates.y;

      this.setCoordinatesToElement(ref._rootElement, coordinates);
    }
  }

  private setCoordinatesToElement(elm: any, coordinates: Coordinates) {
    if(elm && coordinates)
      this.render.setStyle(elm, 'transform',`translate3d( ${coordinates.x}px, ${coordinates.y}px, 0px)`);
  }

  //#endregion

   //#region Utils

   convertConfigurationToJsonString(config : Configuration): string {
    return JSON.stringify(config);
  }

  convertJsonStringToConfiguration(config : string) : Configuration{
    return JSON.parse(config);
  }

    getCurrentCoordinates(): Coordinates{
      let obj :any = this.dragRef;

      return{
        x : obj._activeTransform.x,
        y : obj._activeTransform.y
      }
    }

  getArrayInformation() : ArrayInfo{
    return {
      index : this.dataSource.indexOf(this.entity),
      length : this.dataSource.length
    }
  }

  //#endregion
}
